const API = (
  process.env.REACT_APP_API_URL ||
  "https://faangb2b-prod-api-backend.nicepebble-58ad2aa9.eastus2.azurecontainerapps.io/api"
).replace(/\/$/, "");

export function reviewRoute(pathname, search = "") {
  const match = pathname.match(
    /^\/(share\/interview|share\/listen|interview-recording)\/([A-Za-z0-9_-]{20,128})\/?$/,
  );
  if (!match) return null;
  // Client-facing report links open an audio-only player (?audio=1): the
  // recruiting agency does not want end clients watching the video itself.
  const audioOnly = new URLSearchParams(search || "").get("audio") === "1";
  return {
    token: match[2],
    phone: match[1] === "interview-recording",
    // /share/listen/<token> is a separate, audio-only token: the API never
    // returns video, transcript or questions for it.
    listen: match[1] === "share/listen",
    audioOnly,
  };
}

export async function fetchReview(token, section) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 20000);
  try {
    const suffix = section ? `/details/${section}` : "?review=1";
    const response = await fetch(
      `${API}/public/interview-share/${encodeURIComponent(token)}${suffix}`,
      {
        signal: controller.signal,
        cache: "no-store",
        referrerPolicy: "no-referrer",
        credentials: "omit",
      },
    );
    if (!response.ok) {
      const error = new Error(
        response.status === 404 || response.status === 410
          ? "This link is invalid, expired, or no longer shared."
          : response.status === 403
            ? "This information is not included in this share."
            : response.status === 429
              ? "Too many requests. Please wait a moment and try again."
              : "We could not load this interview. Please try again.",
      );
      error.status = response.status;
      throw error;
    }
    return await response.json();
  } catch (error) {
    if (error.name === "AbortError")
      throw new Error(
        "Loading took too long. Please check your connection and try again.",
      );
    if (error.status) throw error;
    throw new Error(
      "We could not connect. Please check your connection and try again.",
    );
  } finally {
    clearTimeout(timeout);
  }
}

export function formatTime(value) {
  const seconds = Number.isFinite(Number(value))
    ? Math.max(0, Math.floor(Number(value)))
    : 0;
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
}

export function mediaUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === "https:" ||
      (url.origin === window.location.origin && url.protocol === "http:")
      ? url.href
      : null;
  } catch (_) {
    return null;
  }
}

export function timestamp(value) {
  return (
    (typeof value === "number" ||
      (typeof value === "string" && value.trim() !== "")) &&
    Number.isFinite(Number(value)) &&
    Number(value) >= 0
  );
}
